// SHA-256 digests (see skillDirDigest in pi-migrate.ts) of `skills/mu` as
// every released mu tag shipped it. `mu pi migrate` treats a copied skill
// directory as mu-owned only if it hashes to one of these: a copy someone
// edited, or a skill of the same name from elsewhere, never matches.
// Append a new release by hashing its `skills/mu` tree the same way.

export const KNOWN_SKILL_DIGESTS: readonly string[] = [
  "bab34e7d50b31dd9960f64a8192f78f023ce3e9a5dd6a080bda3c7d3aaf68ba8", // v0.2.0
  "a76d272878cb90afc4f5a64ef903a0e80dd3eb7fd92dda23bcbba03854786051", // v0.3.0
  "cb4116919f86bff5c61268cce5059c0965b6c5673d92fb1466ebe654c560425d", // v0.3.1
  "1fc6a019ee71c06d311070058ba76572f6b778e160a5ebd93faeef32002a67dd", // v0.3.2
  "4029bcea85a7470798261041c3626b7fea16f9c84d195a3c4266221e7af4fafb", // v0.4.0
  "272984f7db1812241f8659a71deeac1e7d81367ecf843d6436385d6cec410000", // v0.4.1
  "7d58aebec9bbb40cad90b6da9e9a369cee0aebed03d194ea153c8e4229fbfe16", // v0.4.5
  "e4645a869fbd5153a7390d1cbfe2f3842038f895b4f754a4c44e23512270b5c7", // v1.0.0
  "41479003fe7f7a7d757413dcf31eb46330b9689c70aa0200347aaf6bafd972f1", // v1.0.1
  "1ba368054d76b931639e3dfe02bd53ed8277e47ab28d989ce3bfb7df7497dc7e", // v1.1.0
  "e10e2cf93a31a6b24ce1f19951e1a278299b0c33f8020bd293eff807b24fb20f", // v1.1.1
  "b38c8da4c685b9478aebb13905607bf295af9d9880c7da2aa1e750f24d508e28", // v1.2.0
  "82c14d2c9cbe7bf81f89e4031aeccee8284ffd4ddddea298547b31e1f78bef39", // v1.3.0
  "f787792a820b08aaa7cc338931bf239b5b54e3b536d06127aa8da2d9c938ef5a", // v1.3.2
  "9c5ac614ff9bf3db7d8c5aca3d2d422f8c175efa35533d0c2e174bd74682e073", // v1.4.0
  "6aa1d11a96d9ccd7587e979b8ef2d48d55d9b486f2ccfd160e228c57671cf340", // v1.6.0
  "c33778ae1c9efbb3306395e970c2e9d4a859e19aea11d6ba0429c38ea7f9d05a", // v2.0.0
  "8aabe979d125399274e6ed42c40353f775be61730e4c07c882d16f68d6fd3da8", // v3.0.0
  "bce15b51a9d8b1d0d277e7e3a79ff902d7ab306085c51eb5cb7e8e126b92564c", // v3.1.0
  "7dba4e5b3058e14c4314f886a26a5b5f50b99a3180d5fbe81b4751ac4e187f49", // v3.10.0
  "177fdc1ab4c273eef1ad004732c35fc4820a72b57991e4754d5f53063d782e49", // v3.10.1
  "a648aed46f7e1120ef8fbf021748a40c5434621e036fc443a817899a87dbb028", // v3.11.0
  "ace13205c56b40bb8de0265e4f524eec18a0583b508d7951eb6185c102e4470a", // v3.13.0
  "ff47c6b99435f0b30ef9fea3f6d8384c5718d7c952bbe3cada79b82ea70680fc", // v3.13.2
  "76e5b12be5e78f4b53981718938c33377f896be41b70be88c6feedc0e101af2b", // v3.13.3
  "3bd49e0b22440bd670e915683409e8929579128a9ea3f50d6c7ea3eb6ea124cc", // v3.2.0
  "13428e619c423d8e3dc39772343ac6be12b08b0e648113d791364c447d4f6dee", // v3.2.1
  "258fc3f9212387669f4b8a9442cdebfd04736378fedc4055acf2096b7759e962", // v3.3.0
  "f1a31d16d644bc484b3755ad9019e760098e8f089359cbd12dad3e4570ef14c0", // v3.4.0
  "75cb30f7291b5613df1ffa11d497ff91972c576c625141c6cb7a5ac34f206d6b", // v3.5.0
  "4123cd6e5a19b27bae298a1b56896e06237e8187ace51ccd8aef99c6486a6800", // v3.7.0
  "848eb0fe7fff3108162027f65fe1482675e5ecf074312e9799e6056c6212800f", // v3.8.0
  "7d9784b1c881f545e376a5ddb37da66b589e12b4dadbb204db69767835887546", // v3.8.1
];
